<template>
    <div>
        <Header2 />
        <Banner
            :title="'企业跨境金融服务'"
            :subtitle="'支持“一带一路”'"
            :des="'支持企业“走出去“发展，助推企业“走出去“发展'"
            :backgroundImage="`${require('../../assets/images/backwithsomething.png')}`"
        />
        <div class="road-wrap">
            <LineText style="margin-top:75px;" text="辖内金融机构" />
            <div id="el-carousel-custom">
                <el-carousel
                    :initial-index="Number(initialIndex)"
                    height="630px"
                    :autoplay="false"
                    arrow="always"
                    @change="onChangeCarousel"
                >
                    <el-carousel-item v-for="(item,index) in orgList" :key="index">
                        <div class="content-wrap">
                            <div class="card-content-warp">
                                <Card
                                    class="each-card"
                                    v-for="(subitem,index) in item"
                                    :key="index"
                                    :data="subitem"
                                />
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <LineText style="margin-top:48px;" text="辖内金融产品服务" />
            <div class="bottom-wrap">
                <Selector :data="types" @onSelectEmit="setCurrentType" :initialIndex="currentType" />
                <div class="table-wrap">
                    <TalbeInfor
                        :table="tableData"
                        :page="tableParams"
                        @pageSizeChange="pageSizeChange"
                        @pageChange="pageChange"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header2 from '@/components/Header/index'
import Banner from '@/components/Banner'
import Card from './subcomponent/card'
import LineText from './subcomponent/linetext'
import Selector from './subcomponent/selector'
import TalbeInfor from './subcomponent/tableInfo'

import { splitArrayChunk } from '@/utils/tool'
import { mapActions, mapState, mapMutations } from 'vuex'

export default {
  data () {
    return {
      types: [
        {
          id: '',
          value: '全部'
        }
      ],
      orgList: [],
      value: 5,
      currentType: '',
      initialIndex: 0
    }
  },
  created () {
    this.initialIndex = sessionStorage.getItem('initialIndex') || 0
    this.currentType = sessionStorage.getItem('oneRoadCurrentType') || ''
  },
  async mounted () {
    this.init()
  },
  computed: {
    ...mapState('oneRoad', {
      tableParams: state => state.tableParams,
      tableData: state => state.tableData
    })
  },
  methods: {
    ...mapActions('oneRoad', [
      'fetchBankInfor',
      'fetchProductTypes',
      'fetchProductTable'
    ]),
    ...mapMutations('oneRoad', [
      'SET_TABLE_PARAMS',
      'SET_TABLE_DATA'
    ]),
    init: function () {
      this.fetchBank({ pageSize: '100' })
      this.fetchTypes()
      if (!this.tableData.length) {
        this.fetchTableData()
      }
    },
    fetchBank: async function (params) {
      let res = await this.fetchBankInfor(params)
      let { records } = res.data.data
      this.setBank(records)
    },
    fetchTypes: async function () {
      let res = await this.fetchProductTypes()
      let { data } = res.data
      this.setTypes(data)
    },
    fetchTableData: async function () {
      let res = await this.fetchProductTable({
        type: this.currentType,
        ...{
          pageNo: parseInt(this.tableParams.pageNo),
          pageSize: this.tableParams.pageSize
        }
      })
      let { data } = res.data
      this.setTable(data)
    },
    setBank: function (data) {
      let resarray = splitArrayChunk(data, 6)
      this.orgList = resarray
    },
    setTypes: function (types) {
      this.types = [
        {
          id: '',
          value: '全部'
        }
      ].concat(types)
    },
    setCurrentType: function (key) {
      if (key === this.currentType) {
        return
      }
      sessionStorage.setItem('oneRoadCurrentType', key)
      this.currentType = key
      this.SET_TABLE_PARAMS({ pageNo: 1 })
      // this.tableParams.pageNo = 1
      this.fetchTableData()
    },
    setTable: function (data) {
      // this.tableData = data.records
      this.SET_TABLE_DATA(data.records)
      this.SET_TABLE_PARAMS({ pageNo: data.current })
      // this.tableParams.pageNo = data.current
      this.SET_TABLE_PARAMS({ total: data.total })
      // this.tableParams.total = data.total
    },
    pageChange: function (val) {
      this.SET_TABLE_PARAMS({ pageNo: val })
      // this.tableParams.pageNo = val
      this.fetchTableData()
    },
    pageSizeChange: function (val) {
      this.SET_TABLE_PARAMS({ pageSize: val })
      // this.tableParams.pageSize = val
      this.fetchTableData()
    },
    onChangeCarousel (idx) {
      sessionStorage.setItem('initialIndex', idx)
    }
  },
  components: {
    Header2,
    Banner,
    Card,
    LineText,
    Selector,
    TalbeInfor
    // LabelGroup
    // BankCarousel
  }
}
</script>

<style lang="scss" scoped>
.road-wrap {
    width: 1200px;
    margin: 0 auto;
}

.each-card:nth-child(3n - 1) {
    margin-left: 20px;
    margin-right: 20px;
}

.each-card:nth-child(-n + 2) {
    margin-bottom: 20px;
}

.content-wrap {
    display: flex;
    justify-content: center;
    min-height: 500px;
    .card-content-warp {
        width: 1070px;
        margin-left: 20px;
        display: flex;
        justify-content: start;
        flex-wrap: wrap;
    }
}

.bottom-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 66px;
    margin-bottom: 100px;
    .table-wrap {
        width: 1030px;
        margin-top: 43px;
    }
}
#el-carousel-custom /deep/ {
    .el-carousel__item {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .el-carousel__arrow {
        background-color: white;
        height: 50px;
        i {
            color: rgba(195, 195, 195, 0.8);
            font-size: 50px;
        }
    }
    .el-carousel__button {
        background: rgba(186, 186, 186, 1);
    }
    ul {
        transform: translate(-50%, -10px);
    }
    li .is-active {
        .el-carousel__button {
            background: rgba(186, 186, 186, 1);
        }
    }
}

/deep/ .el-carousel__arrow {
    opacity: 0.6;
}
</style>
